import { render } from "./QuizInfo.vue?vue&type=template&id=2725e56c&scoped=true&ts=true"
import script from "./QuizInfo.vue?vue&type=script&lang=ts"
export * from "./QuizInfo.vue?vue&type=script&lang=ts"

import "./QuizInfo.vue?vue&type=style&index=0&id=2725e56c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2725e56c"]])

export default __exports__